//Formating Functions
export const formatDate = (date) => {
    return new Date(date).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  export const formatDateAndTime = (
    date,
    locale = 'en-US',
    options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true, // ensures AM/PM format
    }
  ) => {
    if (!date) return 'Invalid date';
  
    const parsedDate = new Date(date);
    if (isNaN(parsedDate)) return 'Invalid date';
  
    return parsedDate.toLocaleString(locale, options);
  };
  



  // Sorting an Array
export const sortByDate = (array) => {
    return array.sort((a, b) => new Date(b.date) - new Date(a.date));
  };

  //Capitalizing Strings:
  export const capitalize = (str) => {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  //Validation Functions
  //Email Validation
  export const isValidEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  //Phone Number Validation
export const isValidPhoneNumber = (phone) => {
    const regex = /^\+?[1-9]\d{1,14}$/; // Basic international phone number format
    return regex.test(phone);
  };

    
// Debouncing Functions
export const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(null, args);
      }, delay);
    };
  };

  //LocalStorage Helpers
export const saveToLocalStorage = (key, value) => {
    sessionStorage.setItem(key, JSON.stringify(value));
  };
  
  export const getFromLocalStorage = (key) => {
    const value = sessionStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  };
  
  export const removeFromLocalStorage = (key) => {
    sessionStorage.removeItem(key);
  };
  
  //Random ID Generators
export const generateRandomId = () => {
    return Math.random().toString(36).substr(2, 9);
  };
  
  //Math Utilities
  //Calculate Percentage
  export const calculatePercentage = (partialValue, totalValue) => {
    if (totalValue === 0) return 0;
    return (partialValue / totalValue) * 100;
  };

  // Random Number Generator
export const getRandomInt = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

export const isEmpty = (obj) => {

    // null and undefined are "empty"
    if (obj == null) return true;

    // Assume if it has a length property with a non-zero value
    // that that property is correct.
    if (obj?.length > 0) return false;
    if (obj?.length === 0) return true;

    // If it isn't an object at this point
    // it is empty, but it can't be anything *but* empty
    // Is it empty?  Depends on your application.
    if (typeof obj !== "object") return true;

    // Otherwise, does it have any properties of its own?
    // Note that this doesn't handle
    // toString and valueOf enumeration bugs in IE < 9
    for (var key in obj) {
        if (hasOwnProperty.call(obj, key)) return false;
    }

    return true;
}


export const xmlToJson = (xml) => {
  let obj = {};

  if (xml?.nodeType === 1) { // Element node
      if (xml?.attributes.length > 0) {
          obj["@attributes"] = {};
          for (let i = 0; i < xml.attributes.length; i++) {
              let attr = xml.attributes.item(i);
              obj["@attributes"][attr.nodeName] = attr.nodeValue;
          }
      }
  } else if (xml?.nodeType === 3) { // Text node
      return xml?.nodeValue.trim();
  }

  if (xml?.hasChildNodes()) {
      for (let i = 0; i < xml.childNodes.length; i++) {
          let item = xml.childNodes.item(i);
          let nodeName = item.nodeName;

          if (typeof obj[nodeName] === "undefined") {
              obj[nodeName] = xmlToJson(item);
          } else {
              if (!Array.isArray(obj[nodeName])) {
                  obj[nodeName] = [obj[nodeName]];
              }
              obj[nodeName].push(xmlToJson(item));
          }
      }
  }
  return obj;
}

// Example usage:
export const parseXmlString = (xmlString)=> {
  let parser = new DOMParser(); // Create a new DOMParser instance
  let xmlDoc = parser.parseFromString(xmlString, "text/xml"); // Convert string to XML document
  return xmlDoc;
}

export const getOneMonthFromToday = (month) => {
  const today = new Date(); // Get today's date
  const oneMonthFromToday = new Date(today); // Create a copy of today's date

  // Set the month to one month ahead
  oneMonthFromToday.setMonth(today.getMonth() + month);

 return formatDate(oneMonthFromToday);
}

export const getOneYearFromToday = (year) => {
  const today = new Date(); // Get today's date
  const oneYearFromToday = new Date(today); // Create a copy of today's date

  // Set the year to one year ahead
  oneYearFromToday.setFullYear(today.getFullYear() + year);

  return formatDate(oneYearFromToday);
};



export const getDescriptionByDomainName = (domainName) => {
  if (domainName === "com") {
    return "Best for businesses, organizations, and personal brands.";
  } else if (domainName === "net") {
    return "Great for tech, networking, and infrastructure companies.";
  } else if (domainName === "co") {
    return "Perfect for startups, entrepreneurs, and innovation.";
  } else if (domainName === "site") {
    return "Ideal for personal portfolios, projects, and small businesses.";
  } else if (domainName === "org") {
    return "Best for nonprofits, charities, and communities.";
  } else {
    return "sasda";
  }
};

export const hsvaToHex = (h, s, v, a = 1) => {
  // Convert saturation and value to a 0-1 range
  s /= 100;
  v /= 100;

  const c = v * s; // Chroma
  const x = c * (1 - Math.abs(((h / 60) % 2) - 1)); // Secondary color component
  const m = v - c;

  let r = 0,
    g = 0,
    b = 0;

  if (h >= 0 && h < 60) {
    r = c;
    g = x;
    b = 0;
  } else if (h >= 60 && h < 120) {
    r = x;
    g = c;
    b = 0;
  } else if (h >= 120 && h < 180) {
    r = 0;
    g = c;
    b = x;
  } else if (h >= 180 && h < 240) {
    r = 0;
    g = x;
    b = c;
  } else if (h >= 240 && h < 300) {
    r = x;
    g = 0;
    b = c;
  } else if (h >= 300 && h <= 360) {
    r = c;
    g = 0;
    b = x;
  }

  // Normalize RGB values to [0, 255]
  r = Math.round((r + m) * 255);
  g = Math.round((g + m) * 255);
  b = Math.round((b + m) * 255);

  // Convert alpha to [0, 255]
  const alpha = Math.round(a * 255);

  // Convert RGB(A) to HEX
  const hex = `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
  const hexAlpha =
    a < 1
      ? `${hex}${alpha.toString(16).padStart(2, "0")}` // Include alpha if less than 1
      : hex;

  return hexAlpha.toUpperCase();
};

export const hexToHsva = (hex) => {
  // Remove `#` if present
  hex = hex.replace("#", "");

  // Extract RGB(A) components
  let r,
    g,
    b,
    a = 1; // Default alpha is 1
  if (hex.length === 6) {
    // RGB format
    r = parseInt(hex.substring(0, 2), 16);
    g = parseInt(hex.substring(2, 4), 16);
    b = parseInt(hex.substring(4, 6), 16);
  } else if (hex.length === 8) {
    // RGBA format
    r = parseInt(hex.substring(0, 2), 16);
    g = parseInt(hex.substring(2, 4), 16);
    b = parseInt(hex.substring(4, 6), 16);
    a = parseInt(hex.substring(6, 8), 16) / 255;
  } else {
    throw new Error("Invalid HEX format. Use #RRGGBB or #RRGGBBAA.");
  }

  // Normalize RGB to range [0, 1]
  r /= 255;
  g /= 255;
  b /= 255;

  // Find min and max values
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const delta = max - min;

  // Compute Hue
  let h = 0;
  if (delta !== 0) {
    if (max === r) {
      h = ((g - b) / delta) % 6;
    } else if (max === g) {
      h = (b - r) / delta + 2;
    } else if (max === b) {
      h = (r - g) / delta + 4;
    }
    h *= 60; // Convert to degrees
    if (h < 0) h += 360;
  }

  // Compute Saturation
  const s = max === 0 ? 0 : (delta / max) * 100;

  // Compute Value
  const v = max * 100;

  // Return HSVA
  return {
    h: Math.round(h),
    s: Math.round(s),
    v: Math.round(v),
    a: parseFloat(a.toFixed(2)), // Alpha (0.0 - 1.0)
  };
};





